var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 5.28125C5.34375 5.125 5.34375 4.90625 5.21875 4.75L1.53125 1.125C1.375 0.96875 1.125 0.96875 1 1.125L0.78125 1.34375C0.625 1.5 0.625 1.71875 0.78125 1.875L3.96875 5L0.78125 8.15625C0.625 8.3125 0.625 8.53125 0.78125 8.6875L1 8.90625C1.125 9.0625 1.375 9.0625 1.53125 8.90625L5.1875 5.28125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1591ef55.svg";
export { ForwardRef as ReactComponent };